export interface IUtilityCounterData {
    id: number;
    building_id?: string;
    buildingId?: string;
    type: string;
    number?: null|string;
    ean?: null|string;
    name?: null|string;
    active: boolean;
    info?: null|string;
}

export class UtilityCounterData {
    public id: number;
    public building_id: string;
    public type: string;
    public number: null|string;
    public ean: null|string;
    public name: null|string;
    public active: boolean;
    public info: null|string;

    constructor(data: IUtilityCounterData) {
        this.id = Number(data.id);
        this.building_id = data.building_id ?? data.buildingId ?? "";
        this.type = data.type;
        this.number = data.number ?? null;
        this.ean = data.ean ?? null;
        this.name = data.name ?? null;
        this.active = Boolean(data.active);
        this.info = data.info ?? null;
    }

    public get displayName(): string {
        if (this.name) return this.name;
        if (this.number) return `${this.type} - ${this.number}`;

        return `${this.type} counter ${this.id}`;
    }
}